<template>
  <div class="vz-order-payer-segregated-row">
    <div class="vz-order-payer-segregated-row-title">
      <span>{{ item.title }}</span>
      <span class="ml-10">{{ item.cost }} {{ currencyMeasure }}</span>
    </div>
    <div class="vz-order-payer-segregated-row-column">
      <vz-radiogroup
        v-model="item.payer"
        :items="dispatch"
        :disabled="item.disabled"
        @change="onChange"
      />
    </div>
    <div class="vz-order-payer-segregated-row-column">
      <vz-radiogroup
        v-model="item.payer"
        :items="destination"
        :disabled="item.disabled"
        @change="onChange"
      />
    </div>
    <div class="vz-order-payer-segregated-row-column">
      <vz-radiogroup
        v-model="item.payer"
        :items="third"
        :disabled="item.disabled"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {PropType} from 'vue';
import {CustomerType, OrderService, VzRadioGroupItem} from '~/types/types';
import {useOrderStore} from '~/stores/order';
import VzRadiogroup from '~/components/ui-kit/vz-radiogroup.vue';

const emit = defineEmits(['change'])

const props = defineProps({
  item: {
    type: Object as PropType<OrderService>,
    default: () => ({})
  }
})

const { orderPriceCurrency } = useOrderStore()

const dispatch: VzRadioGroupItem[] = [{
  title: '',
  value: 'dispatch'
}]

const destination: VzRadioGroupItem[] = [{
  title: '',
  value: 'destination'
}]

const third: VzRadioGroupItem[] = [{
  title: '',
  value: 'third'
}]

const payer = ref('destination' as CustomerType)

const currencyMeasure = computed(() => {
  return orderPriceCurrency.currency
})

function onChange(item: any) {
  emit('change', {
    value: item.value,
    guid: props.item.guid
  })
}
</script>

<style lang="scss">

</style>
